import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import { Edit, Code, PauseCircleOutline, PlayCircleOutline, Language, DeleteOutline } from "@material-ui/icons";

const WebFormContextMenu = ({
  anchorEl,
  onClose,
  selectedWebForm,
  onEdit,
  onViewScript,
  onToggleStatus,
  onManageDomains,
  onDelete
}) => (
  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
    <MenuItem onClick={onEdit}>
      <Edit style={{ marginRight: 8, fontSize: 18 }} />
      Editar
    </MenuItem>
    <MenuItem onClick={onViewScript}>
      <Code style={{ marginRight: 8, fontSize: 18 }} />
      Ver / copiar script
    </MenuItem>
    <MenuItem onClick={onManageDomains}>
      <Language style={{ marginRight: 8, fontSize: 18 }} />
      Dominios permitidos
    </MenuItem>
    <MenuItem onClick={onToggleStatus}>
      {selectedWebForm?.status === "activo" ? (
        <>
          <PauseCircleOutline style={{ marginRight: 8, fontSize: 18, color: "#ff9800" }} />
          <span style={{ color: "#ff9800" }}>Pausar</span>
        </>
      ) : (
        <>
          <PlayCircleOutline style={{ marginRight: 8, fontSize: 18, color: "#4caf50" }} />
          <span style={{ color: "#4caf50" }}>Activar</span>
        </>
      )}
    </MenuItem>
    {onDelete && (
      <MenuItem onClick={onDelete}>
        <DeleteOutline style={{ marginRight: 8, fontSize: 18, color: "#e53935" }} />
        <span style={{ color: "#e53935" }}>Eliminar</span>
      </MenuItem>
    )}
  </Menu>
);

export default WebFormContextMenu;
